import LegalLayout from "@/pages/legal/LegalLayout";
import { SITE } from "@/data/site";

export default function Privacy() {
  return (
    <LegalLayout
      testId="privacy-page"
      eyebrow="Legal"
      title="Privacy Policy"
      subtitle="Your trust matters to us. This policy explains how we collect, use and protect your personal information."
      updated="June 2026"
      sections={[
        {
          heading: "Information we collect",
          body: [
            "When you contact us or interact with our website, we may collect information you provide directly, such as your name, email address, phone number, and the contents of your message.",
          ],
          list: [
            "Contact details you submit through our forms",
            "Basic technical data such as browser type and pages visited",
            "Any information you voluntarily share with our team",
          ],
        },
        {
          heading: "How we use your information",
          body: ["We use the information we collect to:"],
          list: [
            "Respond to your enquiries and provide customer support",
            "Improve our website, products and services",
            "Send updates or information you have requested",
          ],
        },
        {
          heading: "How we protect your data",
          body: [
            "We implement reasonable technical and organizational measures to safeguard your personal information against unauthorized access, disclosure, alteration or destruction. However, no method of transmission over the internet is completely secure.",
          ],
        },
        {
          heading: "Sharing your information",
          body: [
            "We do not sell your personal information. We may share information with trusted service providers who help us operate our business, and only to the extent necessary to provide their services.",
          ],
        },
        {
          heading: "Your rights",
          body: [
            "You may request access to, correction of, or deletion of your personal information at any time by contacting us. We will respond to reasonable requests in accordance with applicable law.",
          ],
        },
        {
          heading: "Contact us",
          body: [
            `If you have any questions about this Privacy Policy, please contact ${SITE.legal} at ${SITE.email} or ${SITE.phone}.`,
          ],
        },
      ]}
    />
  );
}
